export default __webpack_public_path__ + "shahbaz.ddf6312c.png";